import React from "react";
import styles from "./FileForm.module.css";
import i18n from "../../Services/i18n";
import TagsInput from "../TagsInput/TagsInput";
import DateTimeService from "../../Services/datetimeService";

const FileForm = ({ formState, onChange, isImage }) => {
  const handleTextChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...formState, [name]: value });
  };

  const handleTagsChange = (value) => {
    onChange({ ...formState, tags: value });
  };

  const handleDateChange = (e) => {
    onChange({ ...formState, selectedDate: e.target.value });
  };

  return (
    <div className={styles.formShell}>
      <div className={styles.row}>
        <div className={styles.col}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="filename">
              {i18n.t("FileUploaderModal.FieldFileName")}
            </label>
            <input
              type="text"
              id="filename"
              name="filename"
              value={formState.filename}
              maxLength={200}
              onChange={handleTextChange}
              className={styles.input}
              placeholder={i18n.t("FileUploaderModal.FieldFileName")}
            />
            <div className={styles.hint}>{i18n.t("FileUploaderModal.FileNameHint") ?? ""}</div>
          </div>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.col}>
          <label className={styles.label}>{i18n.t("FileUploaderModal.FieldTags")}</label>
          <div
            className={styles.tagsWrapper}
            // Empêche la propagation de certains keydown (ex: flèches/esc)
            onKeyDown={(e) => e.stopPropagation()}>
            <TagsInput value={formState.tags} onChange={handleTagsChange} />
          </div>
          <div className={styles.hint}>{i18n.t("FileUploaderModal.TagsHint") ?? ""}</div>
        </div>
      </div>

      <fieldset className={styles.fieldset}>
        <legend className={styles.legend}>{i18n.t("FileUploaderModal.FieldChooseADate")}</legend>

        <label className={styles.radioLine} htmlFor="currentDate">
          <input
            type="radio"
            id="currentDate"
            name="date"
            value=""
            checked={formState.selectedDate === ""}
            onChange={handleDateChange}
          />
          <span>{i18n.t("FileUploaderModal.FieldOptionNowDate")}</span>
        </label>

        {formState.createDate && (
          <label className={styles.radioLine} htmlFor="createDate">
            <input
              type="radio"
              id="createDate"
              name="date"
              value="createDate"
              checked={formState.selectedDate === "createDate"}
              onChange={handleDateChange}
            />
            <span>
              {i18n.t("FileUploaderModal.FieldOptionCreationDate")} (
              {DateTimeService.formatDateString(formState.createDate)})
            </span>
          </label>
        )}

        {formState.modifyDate &&
          (!formState.createDate ||
            formState.modifyDate.getTime() !== formState.createDate.getTime()) && (
            <label className={styles.radioLine} htmlFor="modifyDate">
              <input
                type="radio"
                id="modifyDate"
                name="date"
                value="modifyDate"
                checked={formState.selectedDate === "modifyDate"}
                onChange={handleDateChange}
              />
              <span>
                {i18n.t("FileUploaderModal.FieldOptionEditDate")} (
                {DateTimeService.formatDateString(formState.modifyDate)})
              </span>
            </label>
          )}
      </fieldset>
    </div>
  );
};

export default FileForm;
